import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { PageHeader, Loader, EmptyState } from "@/components/ui-kit";
import KanbanBoard from "@/components/KanbanBoard";
import TaskDialog from "@/components/TaskDialog";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge } from "@/components/StatusBadge";
import { Plus, ListTodo, LayoutGrid, List } from "lucide-react";
import { fmtDate } from "@/lib/api";
import { toast } from "sonner";

export default function Tasks() {
  const [tasks, setTasks] = useState(null);
  const [projects, setProjects] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/tasks").then((r) => setTasks(r.data));
  useEffect(() => { load(); api.get("/projects").then((r) => setProjects(r.data)); api.get("/employees").then((r) => setEmployees(r.data)).catch(() => {}); }, []);

  const move = async (id, statut) => {
    setTasks((prev) => prev.map((t) => (t.id === id ? { ...t, statut } : t)));
    try { await api.patch(`/tasks/${id}/status`, { statut }); } catch (e) { toast.error(apiErr(e)); load(); }
  };

  return (
    <div>
      <PageHeader title="Tâches" subtitle="Organisation des tâches — vue Kanban glisser-déposer">
        <Button onClick={() => { setEditing(null); setOpen(true); }} data-testid="add-task" className="bg-brand-600 hover:bg-brand-700 text-white"><Plus className="h-4 w-4 mr-1.5" />Nouvelle tâche</Button>
      </PageHeader>

      {tasks === null ? <Loader /> : tasks.length === 0 ? (
        <EmptyState icon={ListTodo} title="Aucune tâche" subtitle="Créez des tâches et suivez-les dans le Kanban." />
      ) : (
        <Tabs defaultValue="kanban">
          <TabsList className="mb-4">
            <TabsTrigger value="kanban" data-testid="tab-kanban"><LayoutGrid className="h-4 w-4 mr-1.5" />Kanban</TabsTrigger>
            <TabsTrigger value="list" data-testid="tab-list"><List className="h-4 w-4 mr-1.5" />Liste</TabsTrigger>
          </TabsList>
          <TabsContent value="kanban">
            <KanbanBoard tasks={tasks} onMove={move} onOpen={(t) => { setEditing(t); setOpen(true); }} />
          </TabsContent>
          <TabsContent value="list">
            <div className="rounded-xl border bg-white overflow-hidden"><div className="overflow-x-auto scrollbar-thin">
              <Table>
                <TableHeader><TableRow className="bg-slate-50"><TableHead>Tâche</TableHead><TableHead>Projet</TableHead><TableHead>Responsable</TableHead><TableHead>Échéance</TableHead><TableHead>Priorité</TableHead><TableHead>Statut</TableHead></TableRow></TableHeader>
                <TableBody>
                  {tasks.map((t) => (
                    <TableRow key={t.id} className="hover:bg-slate-50 cursor-pointer" onClick={() => { setEditing(t); setOpen(true); }} data-testid={`task-row-${t.id}`}>
                      <TableCell className="font-semibold">{t.titre}</TableCell>
                      <TableCell className="text-slate-600 text-sm">{t.project_name || "—"}</TableCell>
                      <TableCell className="text-sm">{t.responsable_name || "—"}</TableCell>
                      <TableCell className="text-sm">{fmtDate(t.date_echeance)}</TableCell>
                      <TableCell><StatusBadge value={t.priorite} /></TableCell>
                      <TableCell><StatusBadge value={t.statut} /></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div></div>
          </TabsContent>
        </Tabs>
      )}

      <TaskDialog open={open} onOpenChange={setOpen} initial={editing} projects={projects} employees={employees} onSaved={load} />
    </div>
  );
}
